console.debug(`VUE_APP_ISCACHE: ${process.env.VUE_APP_ISCACHE}`)
// const isCache = process.env.VUE_APP_ISCACHE === 'true' ? true : false
const BASEURL_DOMAIN = process.env.VUE_APP_APIURL_WORLDCUP
const BASEURL_API = process.env.VUE_APP_APIURL_API

// cup 接口 start ---------

function computedBaseUrl(baseApi) {
  // 不同开发环境，不同接口根目录，导致域名不同
  let baseUrl = ''
  if (
    process.env.NODE_ENV === 'development' &&
    process.env.VUE_APP_API === 'development'
  ) {
    // 本地开发
    return baseApi
  }
  if (baseApi.indexOf('/api') === 0) {
    baseUrl = BASEURL_API
  } else {
    baseUrl = BASEURL_DOMAIN
  }
  return baseUrl + baseApi
}

// 获取赛季 接口  （2022卡塔尔，2018俄罗斯...）
export const https_cup_seasonList = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(`${baseUrl}/cmp/findseasoninfos/${params.cid}`)
  )
}

// 赛段粗分 接口
export const https_cup_parstage = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/schedule/findcupparstage/${params.cid}/${params.sid}`
    )
  )
}

// 赛段细分 接口
export const https_cup_allstage = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/schedule/findallstage/${params.cid}/${params.sid}`
    )
  )
}

// 赛季下球队 接口
export const https_cup_stageteammenu = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/schedule/findseasonteammenu/${params.cid}/${params.sid}`
    )
  )
}

// 赛程列表 接口
export const https_cup_groupScheduleList = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/schedule/findcupschedule/${params.cid}/${params.sid}?stage=${params.stage}`
    )
  )
}

// 比赛详情 接口
export const https_cup_scheduleDetail = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/schedule/findmatchinfo/${params.cid}/${params.sid}/${params.mid}`
    )
  )
}

// 比赛详情 AI前瞻接口
export const https_cup_scheduleAIForwardLooking = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/schedule/fetchMatchAIForwardLooking/${params.cid}/${params.sid}/${params.mid}`
    )
  )
}

// 比赛详情-数据统计 球队数据对比 接口
export const https_cup_scheduleDetailStatTeam = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/schedule/findmatchteamstat/${params.cid}/${params.sid}/${params.mid}`
    )
  )
}

// 比赛详情-数据统计 球队数据对比 接口
export const https_cup_scheduleDetailStatPlayers = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/schedule/findmatchplayerstat/${params.cid}/${params.sid}/${params.mid}`
    )
  )
}

// 球队列表 小组 接口
export const https_cup_teamGroup = (baseUrl, axios, params) => {
  let pathUrl = `${baseUrl}/team/findteamgroup/${params.cid}/${params.sid}`
  if (params && params.stageCode) {
    pathUrl = `${baseUrl}/team/findteamgroup/${params.cid}/${params.sid}?stageId=${params.stageCode}`
  }
  return axios.get(computedBaseUrl(`${pathUrl}`))
}

// 单个球队 历史记录 接口
export const https_cup_teamMatchRecord = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/team/findteamseasonmatches/${params.cid}/${params.sid}/${params.tid}`
    )
  )
}

// 单个球队 名单 接口
export const https_cup_teamPlayerList = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/team/findseasonteamplayerposstat/${params.cid}/${params.sid}/${params.tid}`
    )
  )
}

// 单个球队 数据 接口
export const https_cup_teamDetailStat = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/team/findteamdetailstat/${params.cid}/${params.sid}/${params.tid}`
    )
  )
}

// 积分榜阶段 接口
export const https_cup_leagueTableStage = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/standing/getRankStage/${params.cid}/${params.sid}`
    )
  )
}

// 积分榜数据 接口
export const https_cup_leagueTable = (baseUrl, axios, params) => {
  let pathUrl = `${baseUrl}/standing/getRank/${params.cid}/${params.sid}`
  if (params && params.stageCode) {
    pathUrl = `${baseUrl}/standing/getRank/${params.cid}/${params.sid}?stageCode=${params.stageCode}`
  }
  return axios.get(computedBaseUrl(`${pathUrl}`))
}

// 数据-数据概览
export const https_package_getDataOverviewByType = (baseUrl, axios, params) => {
  //templateType： 5、最上面；6、球队数据；7、球员是数据
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/dataoverview/getDataOverviewByType/${params.templateType}/${params.cid}/${params.sid}`
    )
  )
}

// 数据-球队统计-数据类型 接口
export const https_cup_recordTeamDataType = (baseUrl, axios) => {
  return axios.get(computedBaseUrl(`${baseUrl}/datateam/finddataindtypes`))
}

// 数据-球队统计 接口
export const https_cup_recordTeamStat = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/datateam/findseasonteamstat/${params.cid}/${params.sid}?stage=${params.stage}&type=${params.type}&sort=${params.sort}&pnum=${params.pnum}&psize=${params.psize}`
    )
  )
}

// 数据-球员统计-数据类型 接口
export const https_cup_recordPlayerDataType = (baseUrl, axios) => {
  return axios.get(computedBaseUrl(`${baseUrl}/dataplayer/finddataindtypes`))
}

// 数据-球员统计 接口
export const https_cup_recordPlayerStat = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/dataplayer/findseasonplayerstat/${params.cid}/${params.sid}?stage=${params.stage}&tid=${params.tid}&pos=${params.pos}&type=${params.type}&sort=${params.sort}&pnum=${params.pnum}&psize=${params.psize}`
    )
  )
}

// 球员位置 接口
export const https_cup_playerPos = (baseUrl, axios) => {
  return axios.get(computedBaseUrl(`${baseUrl}/player/findplayerpos`))
}

// 球员状态 接口
export const https_cup_playerMatchStatus = (baseUrl, axios) => {
  return axios.get(computedBaseUrl(`${baseUrl}/player/findplayermatchstatus`))
}

// 赛季球员数据 接口
export const https_cup_seasonPlayer = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/player/findseasonplayerspage/${params.cid}/${params.sid}?&tid=${params.tid}&pos=${params.pos}&act=${params.act}&pnum=${params.pnum}&psize=${params.psize}`
    )
  )
}

// 球员详情-数据 接口
export const https_cup_playerDetail = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/player/findseasonplayerdetailstat/${params.cid}/${params.sid}/${params.tid}/${params.pid}`
    )
  )
}

// cup 接口 end ---------

// 测试网络超时
export const https_server_timeOut = (baseUrl, axios, params) => {
  return axios.get(computedBaseUrl(`/testdemo/testdata`))
}
